import Higiene from '../Image/Cosme/higiene.png'
import Mascara from '../Image/Cosme/mascara.png'
import Peeling from '../Image/Cosme/peeling.png'
import PuntosNegros from '../Image/Cosme/puntosNegros.png'
import Radiofrecuencia from '../Image/Cosme/radiofrecuencia.png'
import Punta from '../Image/Cosme/punta.png'
import Acne from '../Image/Cosme/acne.png'
import AltaFrecuencia from '../Image/Cosme/altafrecuencia.png'



const DataCosme = [
    {
        img: Higiene,
        title: "Higiene Facial",
        description: "El scrub es un tratamiento cosmético que ayuda a estimular la renovación de la piel. Para ello, aprovecha la fricción generada por sustancias físicas que, masajeadas sobre la piel, desempeñan una acción exfoliante de tipo mecánico.",
        duracion: "30 min"
    },
    {
        img: Mascara,
        title: "Máscara Facial",
        description: "Se usan comúnmente para hidratar y humectar la piel. Retirar el exceso de grasa y mejorar la apariencia de poros y arrugas.",
        duracion: "40 min"

    },
    {
        img: Peeling,
        title: "Peeling",
        description: "Es un tratamiento químico dermatológico basado en la exfoliación de las capas más superficiales de la piel para favorecer su sustitución por otras de mejor calidad y textura. Se induce así la creación de nuevas capas de la dermis y la epidermis.",
        duracion: "40 min"
    },
    {
        img: Punta,
        title: "Punta de Diamantes",
        description: "Exfoliación mecánica, busca extraer las células muertas con una máquina, sin ocasionar dolor o agredir la piel del rostro. Además de ir puliendo de forma gradual toda las capas y estimular la producción de colágeno que es el objetivo principal.",
        duracion: "30 min"
    },
    {
        img: PuntosNegros,
        title: "Extracción de Puntos Negros",
        description: "El ácido salicílico es tu mejor aliado. Este ácido exfoliante suave desobstruirá tus poros y también tratará el problema de la acumulación de células muertas favoreciendo la renovación celular de la piel sana.",
        duracion: "60 min"

    },
    {
        img: Radiofrecuencia,
        title: "Radiofrecuencia",
        description: "Consiste en el uso de ondas electromagnéticas de alta frecuencia sobre la piel. Su objetivo es calentar las diferentes capas de la dermis con el objetivo de estimular la producción de colágeno, de realizar drenajes linfáticos y de mejorar la circulación, entre otras muchas cosas.",
        duracion: "60 min"
    },
    {
        img: AltaFrecuencia,
        title: "Alta Frecuencia",
        description: "Ayuda a realizar un sellado de los poros para evitar la proliferación de bacterias. Este tratamiento es perfecto para trabajar en pieles sensibles, irritadas o congestionadas por su gran aporte calmante y oxigenante recuperando tersura e hidratación.",
        duracion: "30 min"
    },
    {
        img: Acne,
        title: "Tratamiento Acné",
        description: "Se usa un limpiador delicado de agua micelar en una almohadilla de algodón, luego se aplica un gel de limpieza facial para la piel con tendencia acneica espumoso y especialmente formulado para eliminar la grasa y las bacterias que prosperan en condiciones grasosas. Se extraen las pústulas, se desinfecta con altafrecuencia actuando como anticéptico. ",
        duracion: "90 min"

    }
]

export default DataCosme;